import {usePlaneduHttpService} from "../service/planedu.http.service";
import {TaxEntity} from "../entity/tax.entity";

export function useTaxRepository() {
  const httpService = usePlaneduHttpService<TaxEntity>('tax');

  return {
    ...httpService,
  }
}